import gql from 'graphql-tag';


export const FieldConfigurationFragment = gql`
    fragment CompleteFieldConfiguration on FieldConfiguration {
        id
        field {
            ... on OrdinaryField {
                id
                type
                sectionId
                label
                labels {
                    language
                    translation
                }
            }
            ... on DropdownField {
                id
                type
                sectionId
                label
                labels {
                    language
                    translation
                }
                options {
                    language
                    translations
                }
            }
        }
        editable
        required
        locked
    }
`;

export const CompleteSectionConfigurationFragment = gql`
  fragment CompleteSectionConfiguration on SectionConfiguration {
    id
    labels: names {
      language
      translation
    }
    sortableFields
    fields {
      ...CompleteFieldConfiguration
    }
    editable
  }
  ${FieldConfigurationFragment}
`;

export const AllConfigurationRulesFragment = gql`
  fragment AllConfigurationRules on FormConfigurationRules {
    freePaidStatus
    privatePublicStatus
    eventTypeIds
    defaultLanguage
  }
`;
